module.exports = __webpack_public_path__ + "static/media/image11.edc6e6e9.jpg";